import { CustomSelectFieldProps, SelectField } from 'components/form'
import { DoseImunobiologicoVacinacaoSelectFieldDocument } from 'graphql/hooks.generated'
import {
  DoseImunobiologicoVacinacaoSelectFieldQuery,
  DoseImunobiologicoVacinacaoSelectFieldQueryVariables,
  SexoEnum,
} from 'graphql/types.generated'

import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type DoseImunobiologicoVacinacaoSelectFieldModel = DoseImunobiologicoVacinacaoSelectFieldQuery['doseImunobiologicoVacinacao']['content'][0]

type DoseImunobiologicoVacinacaoSelectFieldProps = CustomSelectFieldProps<
  DoseImunobiologicoVacinacaoSelectFieldModel
> & {
  sexo?: SexoEnum
  imunobiologicoIds?: ID[]
  estrategiaId?: ID
  isRegistroAnterior?: boolean
  semRegras?: boolean
  isOnlyRevacinacao?: boolean
  onlyCalendarioVacinal?: boolean
  grupoAlvoId?: ID
}

export function DoseImunobiologicoVacinacaoSelectField(props: DoseImunobiologicoVacinacaoSelectFieldProps) {
  const {
    sexo,
    imunobiologicoIds,
    estrategiaId,
    isRegistroAnterior,
    semRegras,
    isOnlyRevacinacao,
    onlyCalendarioVacinal,
    grupoAlvoId,
    ...rest
  } = props

  const { selectProps } = useAsyncQuerySelect<
    DoseImunobiologicoVacinacaoSelectFieldModel,
    DoseImunobiologicoVacinacaoSelectFieldQuery,
    DoseImunobiologicoVacinacaoSelectFieldQueryVariables
  >({
    query: DoseImunobiologicoVacinacaoSelectFieldDocument,
    extractItems: (data) => data?.doseImunobiologicoVacinacao?.content,
    variables: (inputQuery: string) => ({
      input: {
        query: inputQuery,
        sexo,
        imunobiologicoIds,
        estrategiaId,
        isRegistroAnterior,
        semRegras,
        isOnlyRevacinacao,
        onlyCalendarioVacinal,
        grupoAlvoId,
        pageParams: {
          ...DEFAULT_SELECT_PAGE_PARAM,
        },
      },
    }),
  })

  const itemToString = (item: DoseImunobiologicoVacinacaoSelectFieldModel) => item?.sigla

  return (
    <SelectField<DoseImunobiologicoVacinacaoSelectFieldModel> itemToString={itemToString} {...selectProps} {...rest} />
  )
}
